module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapterTitle"
  }, [_c('a', {
    attrs: {
      "href": "#/toc01#chap_11",
      "id": "chap11"
    }
  }, [_vm._v("DO ALIENS EXIST?")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterAuthor"
  }, [_vm._v("Dr Seth Shostak")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("astronomer")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("When I was a kid, I would sometimes look up at the night sky with its thousands of stars and wonder: ‘Could there be someone out there?’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Today, aliens – smart creatures that come from planets we’ve never heard of – can be found in a lot of movies and television shows. Aliens are everywhere, it seems. But not everything you see in movies or on TV is true. So what do scientists say about aliens? Do they exist?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The answer is: We still don’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most scientists think it’s possible that real aliens are out there. That’s because the universe is so big. We live in a galaxy called the Milky Way. It’s a very large group of stars, and we believe that our galaxy has about a thousand billion planets. In addition, there are at least a hundred billion "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("other")]), _vm._v(" galaxies we can see with our telescopes. So the number of planets in the visible universe is about the same as the number of sand grains on all the beaches of Earth.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("With so many places where aliens "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("could")]), _vm._v(" exist, it certainly seems reasonable to believe that they really "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" exist.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("How could we find them? Some people think that big-eyed visitors from another world have rocketed across space, and are flying around our skies in saucers. That would be very interesting, but most scientists don’t think it’s true. Why? Because the saucer reports are not convincing. When you see a light in the sky, there are many things it could be. For example, you might be seeing an aeroplane, a balloon or an orbiting satellite. Before scientists will believe that any of these mysterious lights are spaceships from another planet, they want better proof.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Another way to find aliens is to use big antennas to try and pick up radio signals coming from a faraway world. If we could hear a broadcast from another planet, we would know that someone’s out there. Looking for these signals is my job, and so far, I haven’t heard any alien shout-outs. But we’ve only begun to search. I think that by the year 2050, it’s possible we’ll find a signal.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then we’ll know the answer to the question ‘Do aliens exist?’ And the answer will be ‘Yes.’")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-712c7f09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap11.vue
// module id = 102
// module chunks = 0